<template>
  <router-view />
</template>
<script>
export default {
  name: 'ToTripwePay',
  created () {
    this.$store.commit('setBreadcrumbItems', [
        { text: 'Home', routeName: 'Home' },
        { text: 'Balance', routeName: 'TripwePay' },
        { text: 'Transfer', routeName: 'Transfer' },
        { text: 'Transfer Balance', routeName: 'ToTripwePay' }
    ]);
  },
}
</script>